import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';

import { EnvironmentService } from '../../services/environment.service';
import { GlobalsService } from '../../shared/services/globals.service';

function isManagedUrl(url: string, env: EnvironmentService): boolean {
  const managedBases = [env.supergodUrl, env.supergodOtherServerUrl, env.bhiveUrl, env.borServiceUrl];
  return managedBases.some(
    (base) => typeof base === 'string' && base.length > 0 && url.startsWith(base)
  );
}

export const loadingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const globals = inject(GlobalsService);
  const env = inject(EnvironmentService);
  const managed = isManagedUrl(req.url, env);

  if (managed) {
    globals.beginManagedCall();
  } else {
    globals.beginOtherCall();
  }

  return next(req).pipe(
    finalize(() => {
      if (managed) {
        globals.endManagedCall();
      } else {
        globals.endOtherCall();
      }
    })
  );
};
